'use client';

import { createBrowserClient } from '@supabase/ssr';
import type { SupabaseClient } from '@supabase/supabase-js';

// Module-level singleton — one shared instance across the entire app.
// This ensures getSession(), onAuthStateChange, and signInWithPassword all
// operate on the same in-memory cache and the same localStorage entry.
let _browserClient: SupabaseClient | null = null;

export function createClient(): SupabaseClient {
  if (_browserClient) return _browserClient;

  _browserClient = createBrowserClient(
    process.env.NEXT_PUBLIC_SUPABASE_URL!,
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!,
    {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    }
  );

  return _browserClient;
}

// Named singleton export — import { supabase } from '@/lib/supabase/client';
// to guarantee every module shares the exact same client instance.
export const supabase = createClient();
